<template>
	<div>
		<section class="mb-6">
			<p>
				Gaven sendes med posten i hele Norge. Leveringstid er 4-5 dager uten sporing. Du kan sende den hjem til deg selv, eller direkte til
				<strong>{{ giftcard.personalMessageTo || 'mottaker' }}</strong
				>.
			</p>
			<v-radio-group v-model="giftcard.deliveryToReceiver" row>
				<v-radio :value="0" color="primary" class="mb-3" @change="resetShippingInfo(true)" checked>
					<template v-slot:label>
						<span>
							Send gavekortet til
							<strong>meg</strong>
						</span>
					</template>
				</v-radio>
				<v-radio :value="1" color="primary" class="mb-3" @change="resetShippingInfo(false)">
					<template v-slot:label>
						<span>
							Send gavekortet til
							<strong>{{ giftcard.personalMessageTo || 'mottaker' }}</strong>
						</span>
					</template>
				</v-radio>
			</v-radio-group>
		</section>
		<div class="mb-12">
			<v-form v-model="valid">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field
							v-model="giftcard.receiverFirstName"
							label="Fornavn"
							ref="receiver-first-name"
							class="prime"
							placeholder="Fornavn"
							browserAutocomplete="shipping given-name"
							autocomplete="shipping given-name"
							:rules="rules.deliveryFirstName"
						/>
					</v-col>
					<v-col cols="12" md="6">
						<v-text-field
							v-model="giftcard.receiverLastName"
							label="Etternavn"
							class="prime"
							placeholder="Etternavn"
							browserAutocomplete="shipping family-name"
							autocomplete="shipping family-name"
							:rules="rules.deliveryLastName"
						/>
					</v-col>
				</v-row>
				<v-text-field
					v-model="giftcard.deliveryAddress"
					label="Addresse"
					class="prime"
					placeholder="Addresse"
					browserAutocomplete="shipping street-address"
					autocomplete="shipping street-address"
					:rules="rules.deliveryAdress"
				/>

				<v-row>
					<v-col cols="12" md="4">
						<v-text-field
							v-model="giftcard.deliveryPostalCode"
							label="Postnummer"
							v-mask="'####'"
							class="prime"
							placeholder="Postnummer"
							browserAutocomplete="shipping postal-code"
							autocomplete="shipping postal-code"
							:rules="[rules.deliveryPostalCode, rules.deliveryPostalCodeMinLength]"
						/>
					</v-col>
					<v-col cols="12" md="8">
						<v-text-field
							v-model="giftcard.deliveryPostalArea"
							label="Poststed"
							class="prime"
							placeholder="Poststed"
							browserAutocomplete="shipping address-level2"
							autocomplete="shipping address-level2"
							:rules="rules.deliveryPostalName"
						/>
					</v-col>
				</v-row>
			</v-form>
		</div>
	</div>
</template>

<script>
import { GiftCardPurchaseDetails } from '@/services/models';
// import { isEqual } from 'lodash-es';
export default {
	name: 'mail-shipping',
	model: {
		prop: 'giftcard'
	},
	props: {
		giftcard: GiftCardPurchaseDetails,
		value: null, // Current step,
		currentStep: null
		//form: null
	},
	data() {
		return {
			rules: {
				deliveryFirstName: [v => !!v || 'Fornavn er påkrevd', v => v.length <= 50 || 'Maks. 50 tegn tillatt'],
				deliveryLastName: [v => !!v || 'Etternavn er påkrevd', v => v.length <= 50 || 'Maks. 50 tegn tillatt'],
				deliveryAdress: [v => !!v || 'Addresse er påkrevd'],
				deliveryPostalCode: v => !!v || 'Postnummer er påkrevd',
				deliveryPostalCodeMinLength: v => (!!v && v.length == 4) || 'Postnummeret er ugyldig. Må ha 4 tall.',
				deliveryPostalName: [v => !!v || 'Poststed er påkrevd']
			},
			valid: false
		};
	},
	methods: {
		/**
		 * Set shipping information based on logged in user
		 */
		setShippingInfoFromLoggedInUser() {
			if (this.currentStep == 3 && window.CONFIG.user && window.CONFIG.user.onlineSluttKundeId > 0) {
				this.giftcard.receiverFirstName = this.getUserPropertyByLoggedInUser('firstName');
				this.giftcard.receiverLastName = this.getUserPropertyByLoggedInUser('lastName');
				this.giftcard.deliveryAddress = this.getUserPropertyByLoggedInUser('address');
				this.giftcard.deliveryPostalCode = this.getUserPropertyByLoggedInUser('postalCode');
				this.giftcard.deliveryPostalArea = this.getUserPropertyByLoggedInUser('postalArea');
			}
		},
		/**
		 * Reset shipping information
		 */
		resetShippingInfo(value) {
			if (value) {
				this.setShippingInfoFromLoggedInUser();
			} else {
				this.giftcard.receiverFirstName = '';
				this.giftcard.receiverLastName = '';
				this.giftcard.deliveryAddress = '';
				this.giftcard.deliveryPostalCode = '';
				this.giftcard.deliveryPostalArea = '';
			}
			//focusform
			this.$nextTick(() => {
				this.$refs['receiver-first-name'] && this.$refs['receiver-first-name'].focus();
			});
		},
		getUserPropertyByLoggedInUser(property) {
			return this.$user ? this.$user[property] || '' : '';
		}
	},
	computed: {
		// deliverToReceiver: {
		// 	get() {
		// 		return this.form.deliveryToReceiver ? 1 : 0;
		// 	},
		// 	set(value) {
		// 		this.$set(this.form, 'deliveryToReceiver', !!value);
		// 	}
		// }
	},
	watch: {
		// form: {
		// 	deep: true,
		// 	handler(form) {
		// 		if (form) {
		// 			this.$emit('update:giftcard', new GiftCardPurchaseDetails(form));
		// 		}
		// 	},
		// 	immediate: true
		// },

		// giftcard: {
		// 	deep: true,
		// 	handler(giftCard) {
		// 		if (giftCard && !isEqual({ ...giftCard }, this.form)) {
		// 			this.form = { ...giftCard };
		// 		}
		// 	},
		// 	immediate: true
		// },

		// deliverToReceiver: {
		// 	handler(value) {
		// 		if (value) this.resetShippingInfo();
		// 		else this.setShippingInfoFromLoggedInUser();

		// 		// Focus form
		// 		this.$nextTick(() => {
		// 			this.$refs['receiver-first-name'] && this.$refs['receiver-first-name'].focus();
		// 		});
		// 	},
		// 	immediate: true
		// },
		currentStep: function(value) {
			if (value == 3) {
				this.setShippingInfoFromLoggedInUser();
			}
		},
		valid: function(value) {
			this.$emit('onValidationChange', value);
		}
	}
};
</script>

<style scoped></style>
